// UserContext.js
import React, { createContext, useState } from 'react';

// Create the context
export const UserContext = createContext();

// Declare a variable to hold the current user globally
let currentUser = null;

// Helper functions to manage global user state
export const setCurrentUser = (data) => {
  sessionStorage.setItem("currentUser", JSON.stringify(data));
};

export const getCurrentToken = () => {
  const user = JSON.parse(sessionStorage.getItem("currentUser"));
 
  return user || null;
};

export const getCurrentTokenPost = () => {
  const user = JSON.parse(sessionStorage.getItem("currentUser"));

  return user?.Data.Token || null;
};




// Create the provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [isLogged, setIsLogged] = useState(false);

  const addUser = (data) => {
    setUser(data);
    setCurrentUser(data); // update the global variable
    setIsLogged(true);

  };

  const storeUserDataOnly = (data) => {
    setUser({
      MobileNo: data?.Data?.PhoneNumber,
      Code: data?.Data?.Code,
      Email: data.Data.Email,
      UserId: data.Data.UserId,
      CountryID: data.Data.CountryID,
    });
    console.log("User data stored in context:", {
      Code: data.Data.Code,
      MobileNo: data.Data.PhoneNumber,
      Email: data.Data.Email,
      UserId: data.Data.UserId,
      CountryID: data.Data.CountryID,
    });
  };
  const signOut = () => {
    setUser({});
    sessionStorage.removeItem("currentUser");
    setIsLogged(false);
  };

  return (
    <UserContext.Provider value={{ user, isLogged, addUser, storeUserDataOnly, signOut, setIsLogged ,getCurrentToken, getCurrentTokenPost}}>
      {children}
    </UserContext.Provider>
  );
};
